export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-6.png?7ed9b7366256e0b7826ab4e1efc5eb06";